import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import MKTypography from "components/MKTypography";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// Typechecking props for the MKInput

MKFileUploadButton.propTypes = {
  color: PropTypes.string,
  onChange: PropTypes.func,
};

export default function MKFileUploadButton({ color, onChange }) {
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<CloudUploadIcon sx={{ color: color || "white !important" }} />}
    >
      <MKTypography sx={{ color: color || "white" }}>Upload files</MKTypography>
      <VisuallyHiddenInput type="file" onChange={(event) => onChange(event)} multiple />
    </Button>
  );
}
